<template>
  <div class="layout">
    <app-header></app-header>
    <router-view></router-view>
    <app-foot></app-foot>
    <el-footer style="white-space: nowrap;">
      <div class="copyright">
        <span>
          &nbsp;&nbsp;&nbsp;&nbsp;Copyright &copy; 2022 MARKIT 版权所有
        </span>
        <el-link style="font-size: 12px;" href="https://beian.miit.gov.cn/" target="_blank" :underline="false">
          &nbsp;&nbsp;&nbsp;&nbsp;浙ICP备2022008540号-1
        </el-link>
        <span>
          &nbsp;&nbsp;&nbsp;&nbsp;免责声明：网站上的服务均为第三方提供，与 MARKIT 无关。请用户注意甄别服务质量，避免上当受骗。
        </span>
      </div>
    </el-footer>
    <el-backtop target="" :bottom="40" :right="40" :visibility-height="200"></el-backtop>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Foot from '@/components/Foot'
  export default {
    name: 'Layout',
    components: {
      appHeader: Header,
      appFoot: Foot,
    }
  }
</script>

<style lang="less">
  body {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    margin: 0;
    background: #eeeeee;
    // min-width: 889px;

    .layout {

      h1,
      h2,
      h3,
      h4,
      h5 {
        margin: 0;
        position: relative;
      }

      a {
        text-decoration: none;
      }

      ul,
      li {
        list-style: none;
      }

      .app-main {
        max-width: 1200px;
        min-width: 1024px;
        margin: 20px auto;
        -webkit-box-shadow: 0px 0px 15px #ccc;
        -moz-box-shadow: 0px 0px 15px #ccc;
        box-shadow: 0px 0px 15px #ccc;
        background: #fff;
        padding: 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding-bottom: 40px;
      }

      .about-content {
        min-height: 240px;
        border: 2px solid #eeeeee;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        line-height: 35px;
        padding: 0 20px;

        .about-content-head {
          border-bottom: 1px solid #eeeeee;
        }

        .about-content-main {
          padding: 10px 0;
        }
      }

      .about-display {
        margin: 20px auto;

        .about-display-row {
          width: 100%;

          .about-content {
            background: #fff;
            border: 0;
            -webkit-box-shadow: 0px 0px 15px #ccc;
            -moz-box-shadow: 0px 0px 15px #ccc;
            box-shadow: 0px 0px 15px #ccc;

            .about-head-item {
              display: flex;
              justify-content: center;
            }
          }
        }
      }

      .login-register-main {
        min-height: 100vh;

        .el-form {
          // width: 30vw;
          height: 420px;
          margin: calc(25vh - 105px) auto;
          -webkit-box-shadow: 2px 2px 2px #ccc;
          -moz-box-shadow: 2px 2px 2px #ccc;
          box-shadow: 2px 2px 2px #ccc;
          background: #fff;
          padding: 3% 5%;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          -webkit-box-shadow: 0px 0px 15px #ccc;
          -moz-box-shadow: 0px 0px 15px #ccc;
          box-shadow: 0px 0px 15px #ccc;

          .login-title {
            width: 100%;
            text-align: center;
            margin-bottom: 30px;
            color: #696969;

            img {
              width: 100%;
              max-width: 260px;
              height: auto;
            }
          }

          .submit-btn {
            text-align: center;

            button {
              width: 100%;
              height: 40px;
              background: #62D2CE;
              color: #303133;
              border: 0;
              cursor: pointer;
              -webkit-border-radius: 5px;
              -moz-border-radius: 5px;
              border-radius: 5px;
            }

            button:hover {
              background: rgb(64, 158, 255);
              color: #fff;
              transition: .3s;
            }
          }
        }
      }

      .el-footer {
        width: 100%;
        color: #606266;
        font-size: 12px;
        position: relative;
        z-index: 1;

        .copyright {
          display: flex;
          justify-content: center;
          padding: 20px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Layout.vue